import React, { Component } from 'react';
import Icon from '../Icon';
import './styles.scss';
import { NavLink } from 'react-router-dom';

class AdminRoute extends Component {
	render() {
		const {
			title,
			icon,
			backRoute,
			children,
			buttonInactive,
			buttonTheme,
			buttonCta,
			buttonClicked,
			form,
			filters,
			buttonPosition,
			formPosition
		} = this.props;

		let themeClass = '';

		switch (buttonTheme) {
		case 'orange':
			themeClass = 'AdminRoute-button--orange';
			break;
		case 'blue':
			themeClass = 'AdminRoute-button--blue';
			break;
		case 'salmon':
			themeClass = 'AdminRoute-button--salmon';
			break;
		default:
			themeClass = '';
		}

		const AdminRouteButtonClass = ['AdminRoute-button', themeClass].join(' ');

		const iconToSet = themeClass ? 'plus' : 'plusDark';

		return (
			<div className="AdminRoute">
				{title && (
					<div className="AdminRoute-header">
						<Icon icon={icon} />
						<h3 className="AdminRoute-title">{title}</h3>
					</div>
				)}
				<div className="AdminRoute-content">
					<div className="AdminRoute-actions">
						<div style={{ display: 'flex', alignItems: 'center' }}>
							{backRoute && (
								<NavLink style={{ margin: '0 20px 0 0' }} to={backRoute}>
									<Icon icon={'leftArrowTemp'} />
								</NavLink>
							)}
						</div>
						{!buttonInactive &&
							buttonClicked &&
							(!buttonPosition || buttonPosition === 'header') && (
							<button
								className={AdminRouteButtonClass}
								onClick={buttonClicked}
							>
								<Icon icon={iconToSet} /> {buttonCta}
							</button>
						)}
						{filters}
					</div>
					{(!formPosition || formPosition === 'header') &&
						form && <div className="AdminRoute-form">{form}</div>}
					<div className="AdminRoute-table">{children}</div>
					{buttonPosition &&
						buttonPosition === 'footer' && (
						<div className="AdminRoute-footer">
							<button
								className={AdminRouteButtonClass}
								onClick={buttonClicked}
							>
								<Icon icon={iconToSet} /> {buttonCta}
							</button>
						</div>
					)}
					{formPosition &&
						formPosition === 'footer' &&
						form && (
						<div className="AdminRoute-form AdminRoute-form--footer">
							{form}
						</div>
					)}
				</div>
			</div>
		);
	}
}

export default AdminRoute;
